import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import DatabaseKeyPage from "./components/DatabaseKeyPage";
import LoginPage from "./components/LoginPage";
import EmployeeDataGrid from "./components/EmployeeDataGrid";
import ProtectedRoute from "./components/ProtectedRoute";
import { ToastContainer } from "react-toastify";
function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<DatabaseKeyPage />} />
        <Route path="/login" element={<LoginPage />} />

        {/* 🔒 Protect this route */}
        <Route
          path="/employee-data"
          element={
            <ProtectedRoute>
              <EmployeeDataGrid />
             <ToastContainer />
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
